<template>
  <div ref="treeView" data-i="all" class="tree card" :style="{ height }" 
    :class="[{'context-menu-enable': hasContextMenu, 'tree-outer-border': showOuterBorder}]">
    <div class="tree-content d-flex flex-column">
      <div v-if="title" class="tree-title">
        <h5 class="mb-0" v-text="$t(title)"></h5>
        <a v-if="showAddAction" data-i="+" class="btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary"
          :title="$t('추가')">
          <i class="bi bi-plus fs-2"></i>
        </a>
      </div>
      <div v-if="filterHolder != ''" class="tree-search" style="margin: 4px 6px 4px 6px;">
        <div class="icon-btn icon-btn-right">
          <b-form-input maxlength="100" v-model="treeSearchKeyword" @input="filterTree" :placeholder="filterHolder" :title="filterHolder" />
          <a v-if="treeSearchKeyword != ''"
            class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary"
            @click="removeTreeSearchKeyword()">
            <i class="bi bi-x-circle fs-3"></i>
          </a>
        </div>
      </div>
      <div class="tree-body" :class="{'navbar-nav-scroll': !noScrollbar}" :style="[noScrollbar ? {'max-height': '100%'} : {}, {'min-height': minHeight}]">
        <div v-if="showCount > 0" class="tree-list">
          <TreeNodeView :treeData="treeData" :treeId="`tree_${treeIdx}`" :labelKey="labelKey"
            :showRadio="showRadio" :disableRowEvent="disableRowEvent"
            @toggle="toggle" @clicked="clicked" :customAction="customAction"></TreeNodeView>
        </div>
        <div v-else class="d-flex flex-center p-4" style="margin: auto 0;">
          {{this.$t('목록이 없습니다.')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TreeNodeView from "@/components/TreeNodeView.vue";
let treeIdx = 0;

export default {
  components: { TreeNodeView },
  props: {
    size: { default: () => 'md' },
    title: {},
    height: { default: () => 'auto' },
    minHeight: { default: () => 'auto' },
    treeData: Array,
    treeIdx: { default: () => treeIdx++ },
    labelKey: { default: () => 'label' },
    showAddAction: Boolean,
    showRadio: Boolean,
    disableRowEvent: Boolean,
    showOuterBorder: Boolean,
    noScrollbar: Boolean,
    closeAll: Boolean,
    hasContextMenu: { default: () => false },
    customAction: {},
    filterHolder: { default: () => '' },
  },
  computed: {
    showCount() {
      let count = 0, queue = [...this.treeData];
      while (queue.length > 0) {
        const item = queue.shift();
        if(item.show) count++;
        if (item.children && item.children.length) {
          queue.push(...item.children);
        }
      }
      return count;
    }
  },
  data: () => ({
    treeSearchKeyword: '',
    init: false,
  }),
  mounted() {
    this.$refs.treeView.classList.add('tree-' + this.size);
    this.initData();
  },
  watch: {
    treeData: 'initData'
  },
  methods: {
    initData() {
      this.treeSearchKeyword = '';
      if(this.treeData.length > 0) {
        this.procInitData(this.treeData);
        this.init = true;
      }
    },
    procInitData(items, ids = []) {
      items.forEach((item, idx) => {
        this.$set(item, 'closed', item.closed == undefined ? this.closeAll : item.closed);
        this.$set(item, 'show', item.show == undefined ? true : item.show);
        this.$set(item, 'selected', item.selected == undefined ? false : item.selected);
        this.$set(item, 'id', [...ids, idx].join('_'));
        this.$set(item, 'compId', 'tree_' + [...ids, idx].join('_'));
        if(item.children && item.children.length) {
          this.procInitData(item.children, [...ids, idx]);
        }
      });
    },
    removeTreeSearchKeyword() {
      this.treeSearchKeyword = '';
      this.procFilterTree();
    },
    procFilterTree() {
      const regexp = new RegExp(this.treeSearchKeyword, 'i');
      const regexp2 = new RegExp(`(${this.treeSearchKeyword})`, 'gi');

      let queue = [...this.treeData];
      let showIds = [];
      while (queue.length > 0) {
        const item = queue.shift();
        if (regexp.test(item.label)) {
          let ids = item.id.split("_");
          for (let i = ids.length; i > 0; i--) {
            let id = ids.slice(0, i).join("_");
            if(!showIds.includes(id)) showIds.push(id);
          }
        } else {
          this.$set(item, 'show', false);
        }

        if (item.children && item.children.length) {
          queue.push(...item.children);
        }
      }

      queue = [...this.treeData];
      while (queue.length > 0) {
        const item = queue.shift();
        if(showIds.includes(item.id)) {
          item.show = true;
          if(this.treeSearchKeyword != '') item.closed = false;
          this.$nextTick(() => {
            const labelEl = this.$refs.treeView.querySelector(`[data-i="${item.id}"] .item-label`);
            labelEl.innerHTML = item.label.replace(regexp2, '<em class="keyword-emphasis">$1</em>');
          });
        } else {
          item.show = false;
          item.closed = true;
        }

        if (item.children && item.children.length) {
          queue.push(...item.children);
        }
      }
    },
    filterTree() {
      clearTimeout(this.timerFileterTree);
      this.timerFileterTree = setTimeout(() => this.procFilterTree(), 500);
    },
    getItem(key, type) {
      let el;
      if(type) {
        el = this.$refs.treeView.querySelector(`[data-type="${type}"][data-key="${key}"]`);
      } else {
        el = this.$refs.treeView.querySelector(`[data-key="${key}"]`);
      }
      
      if(el) {
        const ids = el.getAttribute('data-i').split('_');
        let item = { children: this.treeData }
        for (const id of ids) {
          item = item.children[id];
        }
        return item;
      }
    },
    getItemByEvt(evt) {
      let el = evt.target.closest('.item');
      const ids = el.dataset.i.split('_');
      let item = { children: this.treeData }
      for (const id of ids) {
        item = item.children[id];
      }
      return item;
    },
    toggle(evt) {
      let item = this.getItemByEvt(evt);
      item.closed = !item.closed;
    },
    deselectAll() {
      let queue = [...this.treeData];
      while (queue.length > 0) {
        const item = queue.shift();
        this.$set(item, 'selected', false);
        if (item.children && item.children.length) {
          queue.push(...item.children);
        }
      }
    },
    clicked(evt) {
      let item = this.getItemByEvt(evt);
      if([...evt.target.parentNode.classList].includes('item-action')) { // 액션 클릭 시
        const action = evt.target.getAttribute('action')
        this.$emit('clicked', {item, action: action || ''});
      } else {
        if(item.selected) return; // 이미 선택 된 아이템일 경우 패스
        this.deselectAll();
        this.$set(item, 'selected', true);
        this.$emit('clicked', {item, action: ''});
      }
    },
    selectItem(key, type) {
      let item = this.getItem(key, type);
      if(item) {
        this.deselectAll();
        this.$set(item, 'selected', true);
        this.$emit('clicked', {item, action: ''});
      }
    },
  },
}
</script>